import React from "react";
import PropTypes from "prop-types";
import Webcam from "react-webcam";
import produce from "immer";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import withMobileDialog from "@material-ui/core/withMobileDialog";

import GridContainer from "../../material-dashboard/components/Grid/GridContainer.jsx";
import GridItem from "../../material-dashboard/components/Grid/GridItem.jsx";
import Button from "../../material-dashboard/components/CustomButtons/Button.jsx";
import Card from "../../material-dashboard/components/Card/Card.jsx";
import CardBody from "../../material-dashboard/components/Card/CardBody.jsx";

// import styles from "../../material-dashboard/assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.jsx";
import consultationStyles from "../styles/consultationStyles.js";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import performanceAnxietyInitial from "../../../../../medical/performanceAnxietyInitial";
import VisitProgress from "./visitProgress.jsx";

import KickClient from "../utils/api.js";
import { bugsnagClient } from "~/shared/utils/errorHandling";
import { trackPhotoUpload } from "../utils/analytics";

import imgPicOfYou from "../../../../images/visits/picture-of-you.svg";
import imgPicOfLicense from "../../../../images/visits/picture-of-drivers-license.svg";

import { Buffer } from "buffer";

import Cookies from "js-cookie";
import { getVisitID, getVisitEmail } from "../utils/visitCookies";

class PhotoUpload extends React.Component {
  constructor(props) {
    super(props);
    const queryParams = new URLSearchParams(this.props.location.search);

    this.state = {
      consultationType: this.props.match.params.consultationType,
      checkoutSessionID: queryParams.get('checkoutSessionID'),
      // currentPicture: ,
      // currentPicture: "you",
      takingPictureOfYou: false,
      takingPictureOfID: false,
      imageSrcYou: null,
      imageSrcID: null,
      uploadForm: null,
      questionError: "",
      disableButton: false,
    };
  }

  setRef = (webcam) => {
    this.webcam = webcam;
  };

  videoConstraints = {
    // width: { min: 640, max: 1280 },
    // height: { min: 480, max: 720 },
    width: 1280,
    height: 720,
    facingMode: "user",
  };

  capture = () => {
    const imageSrc = this.webcam.getScreenshot();
    // alert("Image Captured!");

    if (this.isCurrentPictureOfYou()) {
      this.setState({ imageSrcYou: imageSrc }, () => {});
    } else if (this.isCurrentPictureOfID()) {
      this.setState({ imageSrcID: imageSrc }, () => {});
    }

    this.setState({ questionError: "" });

    this.handleClose();
  };

  isCurrentPictureOfYou = () => {
    return this.props.match.params.photoID == "you";
  };
  isCurrentPictureOfID = () => {
    return this.props.match.params.photoID == "license-id";
  };

  handleClose = () => {
    this.setState({ takingPictureOfYou: false, takingPictureOfID: false });
  };
  takePictureOfYou = () => {
    this.setState({ takingPictureOfYou: true });
  };
  takePictureOfID = () => {
    this.setState({ takingPictureOfID: true });
  };

  nextQuestion = async () => {
    const visitID = getVisitID(this.state.checkoutSessionID);
    if (this.isCurrentPictureOfYou()) {
      if (this.state.imageSrcYou == null) {
        this.setState({
          questionError:
            "Please upload a picture by clicking the 'Picture of You' area above",
        });
        return;
      }

      const path = `/visits/${visitID}/photo-upload/you`;

      this.setState({ disableButton: true });

      var uploadForm = new FormData();

      const blobObj = await (await fetch(this.state.imageSrcYou)).blob();

      uploadForm.append("imageFile", blobObj);
      // uploadForm.append("fileType", )
      // uploadForm.append("fileName", )

      KickClient.newMultipartAuthenticatedClient()
        .post(path, uploadForm)
        .then((response) => {
          // console.log(response);
          //
          try {
            trackPhotoUpload("you");
          } catch (error) {
            bugsnagClient.notify(error);
            console.error(error);
          }

          this.props.history.push(
            `/visits/${this.state.consultationType}/photo-upload/license-id?checkoutSessionID=${this.state.checkoutSessionID}`
          );
          this.setState({ disableButton: false });
        })
        .catch((error) => {
          bugsnagClient.user = {
            email: getVisitEmail(),
          };

          bugsnagClient.notify(error, {
            beforeSend: function (report) {
              report.metaData = {
                cookies: Cookies.get(),
                localStorage: localStorage,
                visit: { visitID: getVisitID(this.state.checkoutSessionID), email: getVisitEmail() },
              };
            },
          });

          // KickClient.logError(error, path, postData, true);
          // alert("Error with visit: ", error);
          this.setState({ disableButton: false });
        });

      // this.props.history.push(
      //   "/visits/performance-anxiety-consultation/photo-upload/license-id"
      // );
    } else {
      if (this.state.imageSrcID == null) {
        this.setState({
          questionError:
            "Please upload a picture by clicking the 'Picture of Your ID' area above",
        });
        return;
      }

      const path = `/visits/${visitID}/photo-upload/license`;
      this.setState({ disableButton: true });

      // console.log("postData: ", JSON.stringify(postData));

      var uploadForm = new FormData();

      // convert the imageURI to a blob to upload in a multipart form
      const blobObj = await (await fetch(this.state.imageSrcID)).blob();

      uploadForm.append("imageFile", blobObj);
      // uploadForm.append("fileType", )
      // uploadForm.append("fileName", )

      KickClient.newMultipartAuthenticatedClient()
        .post(path, uploadForm)
        .then((response) => {
          // console.log(response);
          //
          this.setState({ disableButton: false });

          try {
            trackPhotoUpload("license-id");
          } catch (error) {
            bugsnagClient.notify(error);
            console.error(error);
          }

          this.props.history.push(
            `/visits/${this.state.consultationType}/select-pharmacy?checkoutSessionID=${this.state.checkoutSessionID}`
          );

          window.scrollTo(0, 100);
        })
        .catch((error) => {
          bugsnagClient.notify(error);
          // KickClient.logError(error, path, postData, true);
          this.setState({ disableButton: false });
          // alert("Error with visit: ", error);
        });
    }
  };

  renderWebcamCapture = (youOrID) => {
    const { classes, styles } = this.props;

    return (
      <Dialog
        maxWidth={"md"}
        fullScreen={window.innerWidth < 720}
        open={
          youOrID == "you"
            ? this.state.takingPictureOfYou
            : this.state.takingPictureOfID
        }
        onClose={this.handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"Click Take Photo below to capture"}
        </DialogTitle>

        <DialogContent style={{ padding: 0 }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Webcam
              audio={false}
              width={window.outerWidth < 480 ? window.innerWidth : 800}
              height={window.outerWidth < 480 ? window.innerHeight : 450}
              ref={this.setRef}
              screenshotFormat="image/jpeg"
              screenshotQuality={1.0}
              videoConstraints={
                this.state.takingPictureOfID
                  ? { ...this.videoConstraints, facingMode: "environment" }
                  : this.videoConstraints
              }
            />
          </div>
        </DialogContent>

        <DialogActions>
          <div className={classes.center}>
            <Button
              onClick={this.handleClose}
              style={{ backgroundColor: "#AAAAAA" }}
            >
              Cancel
            </Button>
            <Button onClick={this.capture} color="primary" autoFocus>
              Take Photo
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    );
  };

  renderPictureOfYou() {
    if (this.isCurrentPictureOfYou() && this.state.imageSrcYou != null) {
      return (
        <img
          src={this.state.imageSrcYou}
          style={{ height: "190px", marginBottom: "10px" }}
        />
      );
    } else {
      return (
        <img
          src={imgPicOfYou}
          style={{
            height: "160px",
          }}
          alt="Upload picture of you"
        />
      );
    }
  }

  renderPictureOfID() {
    if (this.isCurrentPictureOfID() && this.state.imageSrcID != null) {
      return <img src={this.state.imageSrcID} style={{ height: "190px" }} />;
    } else {
      return (
        <img
          src={imgPicOfLicense}
          style={{
            height: "180px",
          }}
          alt="Upload picture of your driver's license or ID"
        />
      );
    }
  }

  renderPictureCapturePlaceholder = () => {
    return (
      <div
        style={{
          width: "500px",
          height: "220px",
          // border: "1px solid #CCCCCC",
          marginTop: "10px",
          borderRadius: "5px",
          marginTop: "10px",
          display: "flex",
          alignSelf: "center",
          alignItems: this.isCurrentPictureOfYou() ? "flex-end" : "center",
          justifyContent: "center",
          backgroundColor: "white",
        }}
        onClick={
          this.isCurrentPictureOfYou()
            ? () => this.takePictureOfYou()
            : () => this.takePictureOfID()
        }
      >
        {this.isCurrentPictureOfYou()
          ? this.renderPictureOfYou()
          : this.renderPictureOfID()}
      </div>
    );
  };

  // renderUploadFileLink() {
  //   return this.state.isPhotoUpload ? (
  //     <input
  //       type="file"
  //       accept=".jpg,.png"
  //       onChange={this.handleImageFileChange}
  //       style={{
  //         alignSelf: "center",
  //         border: "1px solid yellow",
  //         marginLeft: "10px",
  //         marginTop: "8px"
  //       }}
  //     />
  //   ) : (
  //     <p
  //       onClick={() => this.setState({ isPhotoUpload: true })}
  //       style={{ alignSelf: "center", marginTop: "4px" }}
  //     >
  //       Select a photo to upload instead
  //     </p>
  //   );
  // }

  renderUploadFileLink() {
    return (
      <div
        onClick={() => this.setState({ isPhotoUpload: true })}
        style={{
          alignSelf: "center",
          textAlign: "center",
          marginTop: "12px",
          width: "500px",
          color: "white",
        }}
      >
        No webcam? Upload a photo instead
        <br />
        <label htmlFor="imageFile" style={{ textDecoration: "underline" }}>
          Select Photo
        </label>
        <input
          id="imageFile"
          type="file"
          accept=".jpg"
          onChange={this.handleImageFileChange}
          style={{ marginLeft: "30px", display: "none" }}
        />
      </div>
    );
  }

  handleImageFileChange = (event) => {
    var reader = new FileReader();

    // store the image as a DataURL in React state so we can display to user and upload later
    reader.addEventListener(
      "load",
      () => {
        if (this.isCurrentPictureOfYou()) {
          this.setState({
            imageSrcYou: reader.result,
          });
        } else if (this.isCurrentPictureOfID()) {
          this.setState({
            imageSrcID: reader.result,
          });
        }
      },
      false
    );

    // console.log("file type: ", event.target.files[0].type);
    // console.log("file name: ", event.target.files[0].name);
    // console.log("file size: ", event.target.files[0].size);

    reader.readAsDataURL(event.target.files[0]);

    // console.log(new FileReader().readAsDataURL(event.target.files[0]).result);
  };

  render() {
    const { classes, styles } = this.props;

    return (
      <React.Fragment>
        <VisitProgress
          //TODO: make this work for sleep visits
          questionNumber={
            this.isCurrentPictureOfYou()
              ? performanceAnxietyInitial.questions.length + 1
              : performanceAnxietyInitial.questions.length + 2
          }
          totalQuestions={performanceAnxietyInitial.questions.length + 2}
        />

        <div
          className={classes.container}
          style={{ backgroundColor: "#3F3F82" }}
        >
          {this.isCurrentPictureOfYou()
            ? this.renderWebcamCapture("you")
            : this.renderWebcamCapture("id")}
          <GridContainer justifyContent="center">
            <GridItem xs={12} sm={12} md={10}>
              <Card
                className={classes.cardConsultation}
                style={{ backgroundColor: "#3F3F82", boxShadow: "none" }}
              >
                <CardBody style={{ border: "" }}>
                  <GridContainer justifyContent="center">
                    <GridItem xs={12} sm={8} md={8}>
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <h3
                          style={{
                            color: "#FFFFFF",
                            fontFamily: "Spectral-SemiBold",
                            fontSize: "32px",
                          }}
                        >
                          {this.isCurrentPictureOfYou()
                            ? " Please take a 'selfie' or upload a photo"
                            : " Please take a photo of your drivers license or government photo ID"}
                        </h3>
                        {this.isCurrentPictureOfYou() && (
                          <p
                            style={{
                              color: "#FFFFFF",
                              fontFamily: "BasisGrotesquePro-Regular",
                              fontSize: "18px",
                              lineHeight: "26px",
                              // letterSpacing: "-0.21px"
                            }}
                          >
                            Doctors are required to verify a patient's identity
                            to protect medical data and issue your prescription.
                          </p>
                        )}
                        {this.isCurrentPictureOfYou() && (
                          <p
                            style={{
                              color: "#FFFFFF",
                              fontFamily: "BasisGrotesquePro-Regular",
                              fontSize: "18px",
                              lineHeight: "26px",
                              // letterSpacing: "-0.21px"
                            }}
                          >
                            All information is encrypted and stored securely.
                          </p>
                        )}
                        {this.isCurrentPictureOfYou() && (
                          <p
                            style={{
                              color: "#FFFFFF",
                              fontFamily: "BasisGrotesquePro-Regular",
                              fontSize: "18px",
                              lineHeight: "26px",
                              // letterSpacing: "-0.21px"
                            }}
                          >
                            Click on the red camera icon below.
                          </p>
                        )}
                        <br />
                        {this.isCurrentPictureOfID() ? (
                          <p
                            style={{
                              color: "#FFFFFF",
                              fontFamily: "BasisGrotesquePro-Regular",
                              fontSize: "18px",
                              lineHeight: "26px",
                              // letterSpacing: "-0.21px"
                            }}
                          >
                            Your ID must include your name and birthday.
                            <br />
                            <br />
                            Please ensure the image isn't blurry. You can retake
                            the photo by clicking on the photo area below.
                          </p>
                        ) : (
                          ""
                        )}
                        {this.renderPictureCapturePlaceholder()}
                        {this.renderUploadFileLink()}
                      </div>

                      <div
                        style={{ color: "red", margin: "20px auto 6px auto" }}
                      >
                        <p style={{ textAlign: "center" }}>
                          {this.state.questionError}
                        </p>
                      </div>

                      <Button
                        disabled={this.state.disableButton}
                        onClick={() => {
                          this.nextQuestion();
                        }}
                        style={{
                          display: "block",
                          backgroundColor: "#F25930",
                          margin: "30px auto",
                          width: "300px",
                        }}
                      >
                        NEXT
                      </Button>
                    </GridItem>
                  </GridContainer>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      </React.Fragment>
    );
  }
}

PhotoUpload.propTypes = {
  classes: PropTypes.object.isRequired,
};

// export default withStyles(consultationStyles)(PhotoUpload);

export default withMobileDialog()(withStyles(consultationStyles)(PhotoUpload));
